import { request } from "../http";

export default {
    // 获取品牌内容分类
    getBrandContentType(params) {
        return request('get', '/sd_smi/api/v1/Web_Brand/getBrandContentType', params, 'json');
    },

    // 获取品牌内容列表
    getBrandContentList(params) {
        return request('get', '/sd_smi/api/v1/Web_Brand/getBrandContentList', params, 'json');
    },

    // 获取品牌内容详情
    getBrandContentDetail(params) {
        return request('get', '/sd_smi/api/v1/Web_Brand/getBrandContentDetail', params, 'json');
    },
    // 获取购物清单详情
    // getClientShoppingInfo(params) {
    //     return request('post', '/sd_smi/api/v1/Web_Calculator/getClientShoppingInfo', params, 'json');
    // }
    getClientShoppingInfo(params) {
        return request('post', '/sd_smi/api/v1/H5_Client/getShoppingDetailList', params, 'json');
    }
}


// WEBPACK FOOTER //
// ./src/request/apis/brand.js